import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpSearchVolumeKeys = {
  all: ['analytics', 'fp-search-volume'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpSearchVolumeKeys.all, 'list', params] as const,
};

export const useFPSearchVolumeData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpSearchVolumeKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPSearchVolume(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
